
import {getAdditionalData} from "~/helpers/formSend";

export default {
  name: "Footer",

  props: {
    vars: {
      type: Object,
      default: () => {
        return {}
      }
    },
    appCfg: {
      type: Object,
      default: () => {
        return {}
      }
    },
    menu: {
      type: Array,
      default: () => {
        return []
      }
    },
    extraMenu: {
      type: Array,
      default: () => {
        return []
      }
    }
  },

  computed: {
    fullAddress: function () {
      return this.vars?.['Полный адрес'] || ""
    },
    workTime: function () {
      return this.vars?.['Время работы'] || ""
    },
    phoneNumber: function () {
      if (!this.vars?.['Телефон']) {
        return ""
      }

      return this.$phoneFormat(this.vars?.['Телефон'])
    },
    emailAddress: function () {
      return this.vars?.["Почтовый адрес"]
    },

    socials: function () {
      let list = [];

      if (this.vars?.["Почтовый адрес"]) {
        list.push({
          icon: require("~/assets/img/svg/socials/Mail.svg"),
          path: `mailto:${this.vars?.["Почтовый адрес"]}`
        })
      }
      if (this.appCfg?.telegram) {
        list.push({
          icon: require("~/assets/img/svg/socials/Telegram.svg"),
          path: this.appCfg?.telegram
        })
      }
      if (this.appCfg?.viber) {
        list.push({
          icon: require("~/assets/img/svg/socials/Viber.svg"),
          path: this.appCfg?.viber
        })
      }
      if (this.appCfg?.whatsapp) {
        list.push({
          icon: require("~/assets/img/svg/socials/WhatsAppGreen.svg"),
          path: this.appCfg?.whatsapp
        })
      }

      return list
    },

    pageAliasPolicy: function () {
      return this.$nuxt?.context?.env?.pageAliasPolicy || "#"
    },

    currentYear: function () {
      return new Date().getFullYear()
    },
    companyAge: function () {
      return Number.parseFloat(this.currentYear) - 2010;
    },

    topMenu: function () {
      let _items = this.$store.state?.cms?.menus?.['footer-main-menu']?.['items'] || [];
      if (_items.length <= 0) {
        return this.menu
      }

      console.log('this', )
      return _items
    }
  },

  components: {
    ExtraMenu: () => import("~/components/Footer/ExtraMenu.vue")
  },

  methods: {
    openMessageToLeader: function () {
      this.$store.commit("back-call/setOpen", {
        open: true,
        settings: {
          type: "Написать руководителю",
          title: "Написать руководителю",
          hideTabs: true,
          hideMessage: true,
        }
      });
    }
  }
}
